import React from 'react';
import {
  Table,
  TableContainer,
} from '@material-ui/core';
import { isNewTypeQuestStart } from '../../../../../utils/functions';
import StreamingSplitTable from './StreamingSplitTable';
import SecondaryCreationSplitTable from './SecondaryCreationSplitTable';

const SplitMode = ({
  fields,
  meta: { error },
  questForm = {},
  quest,
  autoStreamingQuest,
  secondaryCreationQuest
}) => {
  const isNew = !quest || !quest.id;
  const questStarted = React.useMemo(() => {
    if (!questForm.values?.startDateTime || !quest) return false;
    return isNewTypeQuestStart(quest);
  }, [questForm.values?.startDateTime, quest]);

  React.useEffect(() => {
    if (!questForm?.values?.rankTiers?.length && fields.length === 0) {
      const initialValues = autoStreamingQuest ? {
        streamDays: 0,
        streamHours: 0,
        maxRevenue: 0,
        prizePool: 0
      } : secondaryCreationQuest ? {
        totalUploadDays: 0,
        validUploadCount: 0,
        totalViews: 0,
        maxRevenue: 0,
        prizePool: 0
      } : null;

      if (initialValues) {
        fields.push(initialValues);
      }
    }
  }, [fields, questForm?.values?.rankTiers, autoStreamingQuest, secondaryCreationQuest]);

  const handleAddSplitNewTier = React.useCallback(() => {
    const newTier = autoStreamingQuest ? {
      streamDays: 0,
      streamHours: 0,
      maxRevenue: 0,
      prizePool: 0
    } : {
      totalUploadDays: 0,
      validUploadCount: 0,
      totalViews: 0,
      maxRevenue: 0,
      prizePool: 0
    };
    fields.push(newTier);
  }, [fields, autoStreamingQuest]);

  return (
    <section className="WhiteListWrapper">
      <TableContainer>
        <Table>
          {autoStreamingQuest && questForm?.values?.splitTiers?.length > 0 && (
            <StreamingSplitTable
              fields={fields}
              questForm={questForm}
              questStarted={questStarted}
              isNew={isNew}
            />
          )}
          {secondaryCreationQuest && questForm?.values?.splitTiers?.length > 0 && (
            <SecondaryCreationSplitTable
              fields={fields}
              questForm={questForm}
              questStarted={questStarted}
              isNew={isNew}
            />
          )}
        </Table>
      </TableContainer>
      {error && <span className="RepeaterWrapper__error">{error}</span>}
      <button 
        className="RepeaterWrapper__add-item" 
        type="button" 
        onClick={handleAddSplitNewTier}
      >
        Add New Tier
      </button>
    </section>
  );
};

// ...existing PropTypes...

export default React.memo(SplitMode);